import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Map, Zap, ShieldCheck, Wrench, Award } from 'lucide-react';
export function StatsSection() {
  const stats = [{
    value: '24/7',
    label: 'Availability',
    icon: Clock
  }, {
    value: 'Nationwide',
    label: 'Coverage',
    icon: Map
  }, {
    value: '<24hrs',
    label: 'Emergency Response',
    icon: Zap
  }, {
    value: '100+',
    label: 'Fleet Size',
    icon: Wrench
  }];
  const features = [{
    title: 'Turnkey Solutions',
    description: 'From surveying through to commissioning, we offer a complete end-to-end service.',
    icon: ShieldCheck
  }, {
    title: 'Industry Leading Response',
    description: 'In an emergency, we specify, deliver and commission within 24 hours of your call.',
    icon: Zap
  }, {
    title: 'Certified Engineers',
    description: 'Experienced, accredited and certified engineers delivering reliable, excellent service.',
    icon: Award
  }];
  return <section className="py-20 bg-brand-light" data-id="element-191">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-193">
          <h2 className="text-brand-green font-bold tracking-wider uppercase text-sm mb-2" data-id="element-194">
            Why Choose Us
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark" data-id="element-195">
            Your Trusted Partner in Critical Asset Hire
          </h3>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20" data-id="element-196">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm text-center border border-gray-100 hover:border-brand-green transition-colors" data-id="element-197">
              <stat.icon className="w-8 h-8 text-brand-green mx-auto mb-4" data-id="element-198" />
              <div className="text-3xl font-heading font-extrabold text-brand-dark mb-1" data-id="element-199">
                {stat.value}
              </div>
              <div className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-200">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-201">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center p-6" data-id="element-202">
              <div className="w-16 h-16 bg-brand-dark rounded-full flex items-center justify-center mb-6 text-brand-green shadow-lg" data-id="element-203">
                <feature.icon className="w-8 h-8" data-id="element-204" />
              </div>
              <h4 className="text-xl font-heading font-bold text-brand-dark mb-3" data-id="element-205">
                {feature.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-206">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}